import React from "react";

import { MdmDeviceDto, useGetAllDevicesByProjectQuery } from "gql/generated/types";
import { Button } from "primereact/button";
import { useNavigate, useOutletContext } from "react-router-dom";
import { TableColumn } from "utils/types";
import { useGetRecentData } from "api/api-hooks/datasets-hooks";
import { sample } from "lodash-es";
import { Tag } from "primereact/tag";
import ItemsTable from "../components/ItemsTable";

const Devices = () => {
  const projectId = useOutletContext<string>();
  const { data, loading } = useGetAllDevicesByProjectQuery({
    variables: { id: projectId },
    skip: !projectId,
  });
  const navigate = useNavigate();

  const edit = (rowData: MdmDeviceDto) => (
    <Button
      icon="pi pi-external-link"
      title="Device Info"
      className="p-button-rounded p-button-text h-1rem w-1rem p-3"
      onClick={() => navigate(`${rowData.id}`)}
    />
  );

  const handleStatus = (rowData: MdmDeviceDto) => <Status device={rowData} />

  const columns: TableColumn<MdmDeviceDto>[] = [
    { field: "identifier", header: "identifier", sortable: true, filter: true },
    { field: "objectRelation.mdmObject.title", header: "Object Code", sortable: true, filter: true },
    { field: "tags", header: "Tags", body: (rowData) => rowData.tags?.join(", ") },
    { header: "Status", body: handleStatus },
    {
      header: "Actions",
      body: edit,
      style: {
        width: "10%",
      },
    },
  ];
  return (
    <div className="card">
      <ItemsTable
        columns={columns}
        data={data?.mdmDeviceByProjectId as MdmDeviceDto[] ?? []}
        searchFields={["identifier", "tags"]}
        isLoading={loading}
        onToolbarBtnClick={() => navigate("new")}
        toolbarBtnLabel="Add Device"
      />
    </div>
  );
};

export default Devices;


const Status: React.FC<{device: MdmDeviceDto}> = ({device}) => {

  const randomDataset = sample(device.boundDatasets?.allBound);
  if (!randomDataset) return null;
  return <DatasetStatus identifier={randomDataset.identifier} threshold={device.config?.vitalityThreshold!}/>;
}

const DatasetStatus: React.FC<{identifier: string, threshold?: number}> = ({identifier, threshold = 1}) => {
  const {data} = useGetRecentData([identifier], {count: 1});
  if (!data) return null;
  const dataDate = new Date(data[0].data[0]?.key);
  if (!dataDate || Date.now() - dataDate.getTime() > threshold * 1000) {
    return <Tag value="Offline" severity="danger" />;
  }
  if (Date.now() - dataDate.getTime() > 0) {
    return <Tag value="Online" severity="success" />;
  }
  return <Tag value="No Data" severity="danger" />;
}